import { API_BASE_URL } from './../config';
import { createPublicAxios } from './../axios';

const publicSettingsApi = createPublicAxios({
    baseURL: API_BASE_URL + '/public/settings',
});

export const getPublicSetting = (params) => {
    return publicSettingsApi.get(`/search`, {params});
}